import { render, staticRenderFns } from "./ServerSelection.vue?vue&type=template&id=5f81badc&scoped=true&lang=html"
import script from "./ServerSelection.vue?vue&type=script&lang=js"
export * from "./ServerSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f81badc",
  null
  
)

export default component.exports